import { IDirectDebitDetails } from '../types';

export const MAX_ACCOUNT_NUMBER = 9999999;

export const EMPTY_DIRECT_DEBIT: IDirectDebitDetails = {
  fullName: '',
  sortCode: '',
  accountNumber: '',
  accountHolderMandate: undefined,
  creditCheckAgreement: undefined,
};
